import React from "react";

const Form = ({
  className,
  name,
  action,
  honeypot,
  onSubmit,
  onHoneypotValueChange,
  children,
}) => (
  <form
    className={`mform ${className}`}
    name={name}
    method="post"
    action={action}
    data-netlify="true"
    data-netlify-honeypot={honeypot}
    onSubmit={onSubmit}
  >
    <input type="hidden" name="form-name" value={name} />
    <div hidden>
      <label>
        <input name={honeypot} onChange={onHoneypotValueChange} />
      </label>
    </div>
    {children}
  </form>
);
export default Form;
